export { default } from "./src/design-refresh-bar";

export type { UniformDesignRefreshBarProps } from "./src/design-refresh-bar";
